import config from './config';

export const { monitor } = window;

function S4() {
  // eslint-disable-next-line no-bitwise
  return (((1 + Math.random()) * 0x10000) | 0).toString(16).substring(1);
}
function guid() {
  return (`${S4() + S4()}-${S4()}-${S4()}-${S4()}-${S4()}${S4()}${S4()}`);
}

let uuid = window.localStorage.getItem('guid') || 0;
if (!uuid) {
  uuid = guid();
  window.localStorage.setItem('guid', uuid);
}

monitor.setConfig({
  host: 'black-unique.com',
  project: 'front-h5-log',
  performanceLogstore: 'monitor_front',
  errorLogstore: 'monitor_front_error_log',
  projectName: config.monitorProjectName,
  isDebug: config.env !== 'prod',
  uri() {
    return monitor.generatePageUri();
  },
  beforeSend(data) {
    data.service_id = window.localStorage.getItem('guid') || 0;
    data.identify = window.localStorage.getItem('member_id') || '';
    data.BlindUserId = window.localStorage.getItem('BlindUserId') || '';
    return data;
  },
});

export const _ = '';
